import { useRef, useState } from 'react';

import CustomDropdown from '@/components/CustomDropdown';
import ModalContainer from '@/components/modals/ModalContainer';
import { useGetAllBrandsQuery } from '@/api/commonApis';
import { useGetProductActionListQuery, useProductDevelopmentAddMutation } from '@/features/Scan/api/scanApi';
import { toastError, toastSuccess } from '@/components/Toast';
import LoaderComponent from '@/components/LoaderComponent';
import CommonImage from '@/components/CommonImage';

const INITIAL_STATE = {
	task: {},
	brand: {},
	comment: ''
};

const AddTaskModal = ({ onClose, onOpenAddNewTaskModal, productIdList = [] }) => {
	const [taskValues, setTaskValues] = useState(INITIAL_STATE);
	const [errors, setErrors] = useState(null);

	const commentRef = useRef(null);

	const { data: productActionList } = useGetProductActionListQuery();
	const [productDevelopmentAdd, { isLoading }] = useProductDevelopmentAddMutation();

	const handleChange = (value, name) => {
		setTaskValues((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const { data: brandsList } = useGetAllBrandsQuery({
		params: { page: 0, size: 1000 }
	});

	const isValidFields = () => {
		const newErrors = {};
		if (!taskValues?.task?.name) {
			newErrors.task = 'Task name is Required.';
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = () => {
		if (!isValidFields()) {
			return;
		}

		const requestBody = {
			productIdList,
			productActionId: taskValues?.task?.id,
			brandId: taskValues?.brand?.id,
			note: taskValues?.comment
		};

		productDevelopmentAdd({ body: requestBody })
			.unwrap()
			.then(() => {
				toastSuccess('Updated successfully');
				onClose();
			})
			.catch(({ error }) => {
				toastError(error?.data?.message || 'Something went wrong');
			});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<ModalContainer className="update-sample-and-sales-modal">
				<div className="popup-wrapper width-420-modal">
					<div className="common-popup update-sample-and-sales-modal">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-14 mb-0">Update Sample Dev. and sales data</h3>
							</div>
							<div className="close-btn" onClick={onClose}>
								<CommonImage src="/icons/close.svg" alt="close" />
							</div>
						</div>
						<div className="common-popup-body">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="form-group">
										<label htmlFor="task">Select task*</label>
										<CustomDropdown
											items={productActionList?.map((item) => ({
												...item,
												value: item?.name
											}))}
											title="Select task"
											selectedItem={taskValues?.task?.name}
											onItemClick={(item) => handleChange(item, 'task')}
											showAddNewButton
											onAddNewButtonClick={(value) => {
												onOpenAddNewTaskModal();
												onClose(value);
											}}
										/>
										{errors?.task && <span className="error">{errors?.task}</span>}
									</div>
								</div>
								<div className="col-md-12 pr-2">
									<div className="form-group">
										<label htmlFor="brand">Brand</label>
										<CustomDropdown
											items={brandsList}
											title="Select task"
											selectedItem={taskValues?.brand?.name}
											onItemClick={(item) => handleChange(item, 'brand')}
										/>
									</div>
								</div>
								<div className="col-md-12 pr-2">
									<textarea
										ref={commentRef}
										className="form-control"
										placeholder="Comment"
										name="comment"
										value={taskValues?.comment}
										onChange={(e) => {
											commentRef.current.style.height = 'auto';
											commentRef.current.style.height = `${commentRef.current.scrollHeight}px`;
											handleChange(e.target.value, 'comment');
										}}
									/>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2" onClick={onClose}>
									Cancel
								</button>
								<button className="button size32 ml-2" onClick={handleSubmit}>
									Update
								</button>
							</div>
						</div>
					</div>
				</div>
			</ModalContainer>
		</LoaderComponent>
	);
};

export default AddTaskModal;
